import { IClientMessage } from '../interfaces/IClientMessage';
import {
	MessageType,
	isWidgetCommandMessage,
	isCommandMessageSurveyInline,
	isEventMessageSurveyData,
	isEventMessagePostback,
	isCommandMessageForm,
	IChatEventSurveyDataMessage,
	IChatEventPostbackMessage,
	isCommandCloseChannel,
} from '@enuan/chat__utils';

export const isRenderableMessage = <T extends IClientMessage>(message: T) => {
	// splitted for better readability

	const isDisabledCommand =
		isCommandMessageForm(message) &&
		(message._data.parameters.data.hide_when_disabled ||
			typeof message._data.parameters.data.hide_when_disabled ===
				'undefined') &&
		message._meta.disabled;

	const isError = !!message._meta.error;

	if (isDisabledCommand || isError) {
		return false;
	}
	const isDataMessage = ![MessageType.COMMAND, MessageType.EVENT].includes(
		message._type
	);

	const isRenderable =
		isDataMessage ||
		isWidgetCommandMessage(message) ||
		isCommandMessageSurveyInline(message) ||
		isSummaryMessage(message) ||
		isCommandCloseChannel(message);

	return isRenderable;
};

export const isSummaryMessage = <T extends IClientMessage>(
	message: T
): message is T & (IChatEventSurveyDataMessage | IChatEventPostbackMessage) =>
	isEventMessageSurveyData(message) ||
	(isEventMessagePostback(message) &&
		typeof message._data.parameters.payload === 'object');
